import { atom } from "recoil";
import { ILink } from "../types/LinkTypes";

export const LinksAtom = atom<ILink[]>({
  key: "Links",
  default: [],
});
